/* Classic — scroll reveal orquestrado (progressive enhancement).
   Se JS falhar, conteúdo aparece normal (nada é escondido sem JS). */
(function () {
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[id^="cbr-"]'));
    if (!els.length) return;
    els.forEach(function (el) { el.classList.add('cbr-anim'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cbr-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });

    // above-the-fold (hero / buy box) revela já no load, com leve stagger dos filhos diretos
    var top = document.querySelector('[id^="cbr-hero"], [id^="cbr-pdp"], [id^="cbr-models"]');
    if (top) {
      top.classList.add('cbr-in');
      var kids = top.querySelectorAll(':scope > *, :scope > * > *');
    }
    // failsafe: se algo travar, revela tudo depois de 2.2s
    setTimeout(function () { els.forEach(function (el) { el.classList.add('cbr-in'); }); }, 2200);
  } catch (e) { /* noop — conteúdo permanece visível */ }
})();

/* Classic: foto de card com proporcao diferente (classe cbr-encaixe) entra inteira, e o
   resto do quadro ganha a cor das bordas da propria foto. As fotos vem do /cdn/shop do
   proprio dominio, entao o canvas consegue ler os pixels. */
(function () {
  function pinta(img) {
    if (!img || img._cbrCor || !img.complete || !img.naturalWidth) return;
    img._cbrCor = 1;
    try {
      var c = document.createElement('canvas'); c.width = 24; c.height = 24;
      var x = c.getContext('2d'); x.drawImage(img, 0, 0, 24, 24);
      var d = x.getImageData(0, 0, 24, 24).data, r = 0, g = 0, b = 0, n = 0;
      for (var y = 0; y < 24; y++) for (var k = 0; k < 24; k++) {
        if (y > 0 && y < 23 && k > 0 && k < 23) continue;   /* so a moldura */
        var i = (y * 24 + k) * 4; r += d[i]; g += d[i + 1]; b += d[i + 2]; n++;
      }
      var cor = 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')';
      var caixa = img.closest('.media') || img.parentNode;
      caixa.style.backgroundColor = cor;
      /* foto mais alta que o quadro: sobram faixas dos lados, que seguem o degrade
         vertical das bordas esquerda e direita da foto */
      if (img.naturalWidth / img.naturalHeight < caixa.clientWidth / caixa.clientHeight) {
        var paradas = [];
        for (var f = 0; f < 24; f += 2) {
          var s = [0, 0, 0];
          [0, 23].forEach(function (col) {
            for (var q = 0; q < 2; q++) { var j = ((f + q) * 24 + col) * 4; s[0] += d[j]; s[1] += d[j + 1]; s[2] += d[j + 2]; }
          });
          s = [s[0] / 4, s[1] / 4, s[2] / 4];
          /* a roupa encostou na borda nessa altura: fica a cor media do fundo */
          if (Math.abs(s[0] - r / n) + Math.abs(s[1] - g / n) + Math.abs(s[2] - b / n) > 14) s = [r / n, g / n, b / n];
          paradas.push('rgb(' + Math.round(s[0]) + ',' + Math.round(s[1]) + ',' + Math.round(s[2]) + ') ' + Math.round((f + 1) / 24 * 100) + '%');
        }
        caixa.style.backgroundImage = 'linear-gradient(to bottom,' + paradas.join(',') + ')';
      }
    } catch (e) { img._cbrCor = 0; }
  }
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.classList.contains('cbr-encaixe')) pinta(t);
  }, true);
  function todas() {
    var l = document.querySelectorAll('img.cbr-encaixe');
    for (var i = 0; i < l.length; i++) pinta(l[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  window.addEventListener('load', todas);
})();
